module.exports = __webpack_public_path__ + "img/rem11.5c581be3.jpg";